<template>
	<div class="homeview" :style="style">
		<v-header ref="header" />
		<div class="content-box">
			<div class="content" :style="'height:' + (windowHeight-50) +'px;'">
				<router-view v-slot="{ Component }">
					<transition name="move" mode="out-in">
						<keep-alive>
							<component :is="Component" 
								ref="pages"
								@onPrepareLogin="onPrepareLogin"
							/>
						</keep-alive>
					</transition>
				</router-view>
				<!-- <el-backtop target=".content"></el-backtop> -->
				<v-design v-show="$route.path == '/KuJiaLe'"></v-design>
			</div>
		</div>
	</div>
</template>

<script>
import vHeader from "../components/Header";
import vDesign from "./KuJiaLe.vue"
import tool from '../tool/index';
// import { ElMessage, ElMessageBox } from 'element-plus'
import * as SignalR from "@microsoft/signalr"
export default {
    components: {
        vHeader,
		vDesign,
    },
    computed: {
		windowWidth(){
			return this.$store.state.windowWidth;
		},
		windowHeight(){
			return this.$store.state.windowHeight;
		},
		env(){
			return process.env.NODE_ENV
		},
		style(){
			return `width: ${this.windowWidth}px;height: ${this.windowHeight}px;`
		},
        user(){
            return this.$store.state.userInfo
        },		
		tokens(){
			return this.$store.state.tokens
		}
    },
	mounted(){
		// console.log(this.user);
		if (this.user && this.user.ID){
			var lk = localStorage.getItem('LocalKey');
			var time = ''+Date.now();
			this.buildSignalR({
				LoginKey:lk?lk:'',
				Time:''+time,
				designerId:this.user.ID
			})
		}

		// this.$message({
		// 	showClose: true,
		// 	message:this.$t(`酷家乐补单，可由门店自行在酷家乐下单系统中下补单！`, `You can place after after-sales order in the system.`),
		// 	// type: 'info',
		// 	center: true,
		// 	// plain: true,
		// 	duration:0,
		// 	offset: 25,
		// 	customClass:'primary_message',
		// 	icon:'Promotion',
		// })

		this.$message({
			showClose: true,
			message:this.$t(`️现在木皮产品不再需要分开下单！请将木皮产品和其他柜子画在一个方案，并放在一个单号里下单。`, `Veneer items no longer require separate orders; combine with other cabinets in one scheme & order.`),
			type: 'success',
			center: true,
			plain: true,
			duration:0,
			offset: 25,
			icon:'Promotion',
		})
	},
	methods:{
		async buildSignalR(e){
			var that = this;
			// console.log(e);
			var url=""
			// if (this.env == 'zhj') return;
			if (this.env == 'production')
				url = '/SignalR/api/Connect'
			else 
				// url = 'https://localhost:7093/api/Connect'
				url = '/SignalR/api/Connect'
				// url = 'http://10.10.12.249:9810/api/Connect'

			var connection = new SignalR.HubConnectionBuilder()
				// .withUrl('http://localhost:9810/api/Connect') //本地
				.withUrl(url) //线上
				.withAutomaticReconnect().build();
			await connection.start();
			//连接反馈
			connection.on('ConnectResponse', e => { that.$refs['pages'].onConnectResponse(e) });
			connection.on('ConnectError', e => { that.$refs['pages'].onConnectError(e) });
			connection.on('LoginSuccess', (text, lk) => { that.$refs['pages'].onLoginSuccess(text, lk) });
			connection.on('LoginAuditerSuccess', (e) => { that.onLoginAuditerSuccess(e) });
			connection.on('LoginError', e => { that.onLoginError(e) });
			connection.on('PlaceCrmOrderMsg', (e) => { that.$refs['pages'].onPlaceCrmOrderMsg(JSON.parse(e)) });
			connection.on('CreateScnResult', (e) => { /*console.log(e);*/ that.$refs['pages'].onCreateScnResult(JSON.parse(e)) });
			connection.on('ExecuteCrmOrderMsg', (text, ts) => { console.log('ExecuteCrmOrderMsg'); that.onDealMessage(text, ts, that.$refs['pages'].onExecuteCrmOrderMsg) });
			connection.on('CrmOrderSubLightMsg', (e) => { that.$refs['pages'].onCrmOrderSubLightMsg(JSON.parse(e)) });
			connection.on('CrmOrderSubDetectMsg', (e) => { /*console.log(e);*/ that.$refs['pages'].onCrmOrderSubDetectMsg(JSON.parse(e)) });
			connection.on('CrmOrderQuoteMsg', (e) => { /*console.log(e);*/ that.$refs['pages'].onCrmOrderQuoteMsg(JSON.parse(e)) });
			connection.on('CrmOrderAllQuoteMsg', (e) => { /*console.log(e);*/ that.$refs['pages'].onCrmOrderAllQuoteMsg(JSON.parse(e)) });
			connection.on('PlaceASOrderMsg', (e) => { that.$refs['pages'].onPlaceASOrderMsg(JSON.parse(e)) });
			connection.on('PlaceSBOrderMsg', (e) => { that.$refs['pages'].onPlaceSBOrderMsg(JSON.parse(e)) });
			connection.on('PlaceEPOrderMsg', (e) => { that.$refs['pages'].onPlaceEPOrderMsg(JSON.parse(e)) });
			connection.on('NoticeAllCrmAccount', (e) => { that.onSystemNotice(JSON.parse(e)) });
			connection.on('SystemNotice', (e) => { that.onSystemNotice(JSON.parse(e)) });

			// console.log(typeof(e.LoginKey), typeof(e.Time));
			if (e.designerId){
				await connection.invoke("Connect",e.Time, e.LoginKey, e.designerId); //发送消息

			} else {
				await connection.invoke("Connect",e.Time, e.LoginKey, null); //发送消息
				this.$store.commit("addTokens",{ time:e.Time, token:`KFKJL#${e.Time.substr(-6)}@FCH` });
			}
				
		},
		onConnectResponse(e){
			console.log(e);
			if (this.$refs['pages'].onConnectResponse){
				this.$refs['pages'].onConnectResponse(e)
			} else {
				localStorage.setItem('LocalKey',e)
			};
		},
		onConnectError(e){
			console.log(e);
			// this.$refs['pages'].onConnectError(e);			
            console.log(err);
            this.$message({
                message: err,
                type: 'error',
            })
		},
		onLoginSuccess(text, lk){
			// console.log(text, lk);
			this.$refs['pages'].onLoginSuccess(text, lk);
		},
        onLoginAuditerSuccess(res){
			// console.log(res);
			if (res.stateCode == 200){
				this.$store.commit("setAuditerInfo",tool.deepClone(res.data.sysUser));
				delete res.data.sysUser;
				this.$store.commit("setKdMagInfo",res.data);
				// console.log(this.$store.state.userInfo);
				// console.log(this.$store.state.kdMagInfo);
				// // console.log(this.$store.state.tokens);
			} else {
				console.log(res.errMsg); 
				this.$message.error(this.$t(res.errMsg, res.errMsgEn))
			}
        },
		onLoginError(e){
			console.log(e);
			// this.$refs['pages'].onLoginSuccess(e);
		},
		// onPlaceCrmOrderMsg(text, ts){
		// 	// console.log(text);
		// 	try {
		// 		var token = this.$store.state.tokens[ts]
		// 		var obj = JSON.parse(tool.AES_ECB_DECRYPT(text, token));
		// 		console.log(obj);
		// 		if (obj && typeof(obj) == 'object'){
		// 			if (obj.timeStamp && obj.token){
		// 				this.$store.commit("addTokens",{ time:obj.timeStamp, token:obj.token })
		// 			}
		// 		}
		// 		this.$refs['pages'].onPlaceCrmOrderMsg(obj);
		// 	} catch (error) {
		// 		console.log(error);
		// 	}

		// },
		// onCreateScnResult(text, ts){
		// 	// console.log(text);
		// 	try {
		// 		var token = this.$store.state.tokens[ts]
		// 		var obj = JSON.parse(tool.AES_ECB_DECRYPT(text, token));
		// 		console.log(obj);
		// 		if (obj && typeof(obj) == 'object'){
		// 			if (obj.timeStamp && obj.token){
		// 				this.$store.commit("addTokens",{ time:obj.timeStamp, token:obj.token })
		// 			}
		// 		}
		// 		this.$refs['pages'].onCreateScnResult(obj);
		// 	} catch (error) {
		// 		console.log(error);
		// 	}

		// },
		// onExecuteCrmOrderMsg(text, ts){
		// 	try {
		// 		var token = this.$store.state.tokens[ts]
		// 		var obj = JSON.parse(tool.AES_ECB_DECRYPT(text, token));
		// 		console.log(obj);
		// 		if (obj && typeof(obj) == 'object'){
		// 			if (obj.timeStamp && obj.token){
		// 				this.$store.commit("addTokens",{ time:obj.timeStamp, token:obj.token })
		// 			}
		// 		}
		// 		this.$refs['pages'].onCreateScnResult(obj);
		// 	} catch (error) {
		// 		console.log(error);
		// 	}
		// }

		onPrepareLogin(e){
			// console.log(e);
			this.buildSignalR(e)
		},
		onDealMessage(text, ts, f){
			var that = this;
			// console.log('onDealMessage');
			// console.log(this.$refs);
			try {
				if (!f){
					throw "f is undefind or null"
				}
				var token = this.$store.state.tokens[ts]
				// console.log(tool.AES_ECB_DECRYPT(text, token));
				// console.log(tool.AES_ECB_DECRYPT(text, token));
				var obj = JSON.parse(tool.AES_ECB_DECRYPT(text, token));
				console.log(obj);
				if (obj && typeof(obj) == 'object'){
					if (obj.timeStamp && obj.token){
						this.$store.commit("addTokens",{ time:obj.timeStamp, token:obj.token })
					}
				}
				f(obj);
			} catch (error) {
				// console.log(error);
				if (!f){
					setTimeout(()=>{
						that.onDealMessage(text, ts, that.$refs['pages'].onExecuteCrmOrderMsg)
					},1000)
				}
			}
		},
		onSystemNotice(e){
			console.log(e);
			this.$notify({
				title: e.Title,
				message: e.Message,
				type: e.State,
				duration:0,

			})
		}
	}
};
</script>

<style scoped>
.homeview{
	margin: 0px !important;
	padding: 0px !important;
}
</style>

<style>
.page{
	background-color: #f5f5f5;
	height: 100%;
}
.primary_message{
	--el-message-bg-color: var(--el-color-primary-light-9) !important;
    --el-message-border-color: var(--el-color-primary-light-8) !important;
    --el-message-text-color: var(--el-color-primary) !important;
}
</style>
